export const formatFields = (fields) => {
	return formatVisitorQuestFields(fields);
}

function formatVisitorQuestFields({
	VADOCEmployee,
	activeParole,
	felonyConviction,
	protectiveOrder,
	gangAssociation
}) {
	let VADOCEmployeeFormat,
	activeParoleFormat,
	felonyConvictionFormat,
	protectiveOrderFormat,
	gangAssociationFormat;

	VADOCEmployee.value === "no" ? 
		VADOCEmployeeFormat = "You are not currently or formerly a VADOC employee, contractor, or volunteer." :
		VADOCEmployeeFormat = "You are currently or formerly a VADOC employee, contractor, or volunteer.";

	activeParole.value === "no" ?
		activeParoleFormat = "You are not currently under active parole or probation supervision." :
		activeParoleFormat = "You are currently under active parole or probation supervision.";

	felonyConviction.value === "no" ?
		felonyConvictionFormat = "You have never been convicted of a felony." :
		felonyConvictionFormat = "You have been convicted of a felony.";

	protectiveOrder.value === "no" ?
		protectiveOrderFormat = "You are not banned from having contact with the inmate under an existing protective order, no-contact order, or Child Protective Services/Adult Protective Services ruling." :
		protectiveOrderFormat = "You are banned from having contact with the inmate under an existing protective order, no-contact order, or Child Protective Services/Adult Protective Services ruling."; 

	gangAssociation.value === "no" ?
		gangAssociationFormat = "You have never been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1." :
		gangAssociationFormat = "You have been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1.";

	return {
		VADOCEmployee: VADOCEmployeeFormat,
		activeParole: activeParoleFormat,
		felonyConviction: felonyConvictionFormat,
		protectiveOrder: protectiveOrderFormat,
		gangAssociation: gangAssociationFormat
	}

}


// WEBPACK FOOTER //
// ./src/utils/formatFields.js